import { Skeleton } from '@gto/ui/skeleton'

/** Enough 36px bars to fill a tall body, so the card does not sit half-empty on first load. */
const SKELETON_ROWS = 20

/**
 * Initial-load skeleton behind the `isPending` gate (no empty flash). Rows are
 * decorative (`aria-hidden`) — the `aria-busy` container + live region carry the
 * loading semantics.
 *
 * Deliberately the simple stacked-bar shape (one full-width bar per row), NOT a
 * per-column segmentation on the real tracks: FE-836 shipped the segmented variant
 * and rolled it back on QA — the row-shaped grid read as noise next to this quiet
 * stack.
 */
export const InitialLoadingState = () => (
  <div
    aria-hidden
    className="flex flex-col gap-2 overflow-hidden p-3"
    data-table-state="initialLoading"
  >
    {Array.from({ length: SKELETON_ROWS }, (_, index) => (
      // `shrink-0`: the overlay fills a height-BOUNDED body, and a flex column shrinks
      // every child to fit — 20 bars compressed to ~23px each (the "tiny rows" QA report).
      // Fixed bars + `overflow-hidden` on the container clips the surplus instead.
      <Skeleton
        key={index}
        className="shrink-0"
        height={36}
        variant="rounded"
        width="100%"
      />
    ))}
  </div>
)
